<template>
  <el-row>
    <div
      v-if="isConfig"
      style="display: flex; position: relative; float: right"
    >
      <!-- FITLRO DE AÑO -->
      <div class="box">
        <el-select v-model="year" placeholder="Año" size="mini">
          <el-option
            v-for="item in years"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <!-- FITLRO DE METAS -->
      <div class="box">
        <el-select
          v-model="typeFilter"
          clearable
          placeholder="Metas"
          size="mini"
        >
          <el-option
            v-for="item in metas"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>

      <seller-selector v-model="sellerId" />
    </div>

    <el-col>
      <el-button
        type="primary"
        @click="drawer = true"
        style="margin-bottom: 10px"
        >Añadir Meta</el-button
      >
      <rabbey-table-3
        ref="table"
        :actions="actions"
        :loading="autoLoading"
        :columns="columnsMothns"
        :data="data"
        @rtable-push-action="onPushAction"
      ></rabbey-table-3>
    </el-col>
    <deal-report-detail-pr-ct ref="detail" @getUpdatedData="refreshData2" />

    <el-drawer
      title="NUEVA META"
      size="55%"
      :visible.sync="drawer"
      :before-close="handleClosed"
      @closed="handleClosed"
    >
      <div style="padding: 50px; height: 100%; background: rgb(233, 233, 233)">
        <el-form
          ref="form"
          class="demo-form"
          label-position="top"
          :rules="rules"
          :model="ruleForm"
        >
          <div style="display: block">
            <div style="display: inline-flex; float: right">
              <el-form-item label="Año" prop="YearGoal">
                <!-- FITLRO DE AÑO -->
                <el-select
                  v-model="ruleForm.YearGoal"
                  placeholder="Año"
                  size="mini"
                >
                  <el-option
                    v-for="item in years"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Seleccionar vendedor" prop="seller_filter">
                <seller-selector v-model="ruleForm.seller_filter" />
              </el-form-item>
              <el-form-item label="Tipo de meta" prop="metasValue">
                <el-select
                  v-model="ruleForm.metasValue"
                  clearable
                  placeholder="Metas"
                  size="mini"
                >
                  <el-option
                    v-for="item in metas"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>

            <div
              style="
                display: flex;
                justify-content: flex-end;
                width: 100%;
                gap: 10px;
              "
            >
              <el-card class="cardInputs"
                ><h3>Q1</h3>
                <el-form-item label="Enero" prop="JanuaryGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.JanuaryGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Febrero" prop="FebruaryGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.FebruaryGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Marzo" prop="MarchGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.MarchGoal"
                  ></el-input-number>
                </el-form-item>
              </el-card>

              <el-card class="cardInputs"
                ><h3>Q2</h3>
                <el-form-item label="Abril" prop="AprilGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.AprilGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Mayo" prop="MayGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.MayGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Junio" prop="JuneGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.JuneGoal"
                  ></el-input-number>
                </el-form-item>
              </el-card>

              <el-card class="cardInputs"
                ><h3>Q3</h3>
                <el-form-item label="Julio" prop="JulyGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.JulyGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Agosto" prop="AugustGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.AugustGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Septiembre" prop="SeptemberGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.SeptemberGoal"
                  ></el-input-number>
                </el-form-item>
              </el-card>

              <el-card class="cardInputs"
                ><h3>Q4</h3>
                <el-form-item label="Octubre" prop="OctoberGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.OctoberGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Noviembre" prop="NovemberGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.NovemberGoal"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Diciembre" prop="DecemberGoal">
                  <el-input-number
                    :controls="false"
                    v-model="ruleForm.DecemberGoal"
                  ></el-input-number>
                </el-form-item>
              </el-card>
            </div>
            <el-form-item style="margin-top: 40px; float: right">
              <el-button
                type="info"
                :disabled="autoLoading"
                :loading="autoLoading"
                @click="handleClosed()"
                >Cancel</el-button
              >
              <el-button
                type="primary"
                :disabled="autoLoading"
                :loading="autoLoading"
                @click="AddGoalSeller()"
                >Create</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-drawer>
    <GoalsFormDrawer
      ref="GoalsFormDrawer"
      :title="drawerTitle"
      :drawer.sync="drawerEditar"
      :loading="true"
      :type="typeForDrawer"
      :codeVendor="codeVendorForDrawer"
      :JanuaryDra="JanuaryForDrawer"
      :FebruaryDra="FebruaryForDrawer"
      :MarchDra="MarchForDrawer"
      :AprilDra="AprilForDrawer"
      :MayDra="MayForDrawer"
      :JuneDra="JuneForDrawer"
      :JulyDra="JulyForDrawer"
      :AugustDra="AugustForDrawer"
      :SeptemberDra="SeptemberForDrawer"
      :OctoberDra="OctoberForDrawer"
      :NovemberDra="NovemberForDrawer"
      :DecemberDra="DecemberForDrawer"
      :YearDra="YearDrawer"
      :before-close="handleClosed"
      @closed="handleClosed"
      @updateGoal="refreshData2()"
    />
  </el-row>
</template>
<!-- v-bind="goalBind" -->

<script>
import DealReportDetailPrCt from "./DealReportDetailPrCt.vue";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import SellerSelector from "@/components/Company/SellerSelector.vue";
import GoalsFormDrawer from "@/components/deals/GoalsFormDrawer.vue";
import { formatMonto } from "@/utils";
export default {
  name: "DealReportByPhase",
  props: {
    isConfig: {
      type: Boolean,
      default: true
    },
    module: {
      type: String,
      default: null,
      required: false
    },
    sellerId: {
      type: Number,
      default: null,
      required: false
    },
    typeFilter: {
      type: Number,
      default: null,
      required: false
    }
    /*productId: {
      type: Number,
      default: 0,
      required: false
    },*/
    // year: {
    //   type: Number,
    //   default: new Date().getFullYear()
    // }
    /*phaseId: {
      type: String,
      default: "0"
    }*/
  },
  components: {
    DealReportDetailPrCt,
    SellerSelector,
    GoalsFormDrawer
  },
  data() {
    return {
      metasValue: "",
      seller_filter: "",
      year: new Date().getFullYear(),
      ruleForm: {
        //DATA PARA EL FORMULARIO DE AÑADIR
        JanuaryGoal: "",
        FebruaryGoal: "",
        MarchGoal: "",
        AprilGoal: "",
        MayGoal: "",
        JuneGoal: "",
        JulyGoal: "",
        AugustGoal: "",
        SeptemberGoal: "",
        OctoberGoal: "",
        NovemberGoal: "",
        DecemberGoal: "",
        YearGoal: new Date().getFullYear(),
        seller_filter: "",
        metasValue: ""
      },
      rules: {
        JanuaryGoal: [
          {
            required: true,
            message: "Meta enero es necesario",
            trigger: "blur"
          }
        ],
        FebruaryGoal: [
          {
            required: true,
            message: "Meta Febrero es necesario",
            trigger: "change"
          }
        ],
        MarchGoal: [
          {
            required: true,
            message: "Meta Marzo es necesario",
            trigger: "change"
          }
        ],
        AprilGoal: [
          {
            required: true,
            message: "Meta Abril es necesario",
            trigger: "change"
          }
        ],
        MayGoal: [
          {
            required: true,
            message: "Meta Mayo es necesario",
            trigger: "change"
          }
        ],
        JuneGoal: [
          {
            required: true,
            message: "Meta Junio es necesario",
            trigger: "change"
          }
        ],
        JulyGoal: [
          {
            required: true,
            message: "Meta Julio es necesario",
            trigger: "change"
          }
        ],
        AugustGoal: [
          {
            required: true,
            message: "Meta Agosto es necesario",
            trigger: "change"
          }
        ],
        SeptemberGoal: [
          {
            required: true,
            message: "Meta Septiembre es necesario",
            trigger: "change"
          }
        ],
        OctoberGoal: [
          {
            required: true,
            message: "Meta Octubre es necesario",
            trigger: "change"
          }
        ],
        NovemberGoal: [
          {
            required: true,
            message: "Meta Noviembre es necesario",
            trigger: "change"
          }
        ],
        DecemberGoal: [
          {
            required: true,
            message: "Meta Septiembre es necesario",
            trigger: "change"
          }
        ],
        YearGoal: [
          {
            required: true,
            message: "Año es necesario",
            trigger: "change"
          }
        ],
        seller_filter: [
          {
            required: true,
            message: "Vendedor es necesario",
            trigger: "change"
          }
        ],
        metasValue: [
          {
            required: true,
            message: "Tipo de meta es necesario",
            trigger: "change"
          }
        ]
      },
      loading: false,
      drawer: false,
      drawerEditar: false,
      autoLoading: false,
      data: [],
      CompanyIDD: "TB",
      initModel: {},
      //DATA PARA EL FORMULARIO DE EDITAR
      typeForDrawer: "",
      codeVendorForDrawer: "",
      JanuaryForDrawer: 0,
      FebruaryForDrawer: 0,
      MarchForDrawer: 0,
      AprilForDrawer: 0,
      MayForDrawer: 0,
      JuneForDrawer: 0,
      JulyForDrawer: 0,
      AugustForDrawer: 0,
      SeptemberForDrawer: 0,
      OctoberForDrawer: 0,
      NovemberForDrawer: 0,
      DecemberForDrawer: 0,
      YearDrawer: 0,

      row: null,
      drawerTitle: "",
      metas: [
        { label: "Venta", value: 1 },
        { label: "Prospección", value: 2 },
        { label: "Presentación", value: 3 },
        { label: "Cotización", value: 4 }
      ],
      actions: [
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit"
        }
      ],
      columnsMothns: [
        {
          prop: "NombreVendedor",
          label: "Vendedor",
          fixed: true,
          minWidth: 260,
          formatter: ImagePersonVue,
          attrs: {
            imgKey: "SalesPersonPhoto"
          },
          sortable: true
        },
        {
          prop: "Type",
          label: "Tipo",
          fixed: true,
          minWidth: 140,
          formatter: (props) => {
            if (props.Type == 1) {
              return "Venta";
            } else if (props.Type == 2) {
              return "Prospeccion";
            } else if (props.Type == 3) {
              return "Presentacion";
            } else if (props.Type == 4) {
              return "Cotizacion";
            }
          }
        },

        {
          prop: "January",
          name: "Enero",
          label: "Enero",
          minWidth: 100,
          cellAtrrs: {
            mes: 1,
            mes2: "January"
          },
          formatter: (props) => {
            if (props.January == 0) {
              return "";
            }
            return formatMonto(props.January);
          }
        },
        {
          prop: "February",
          name: "Febrero",
          label: "Febrero",
          minWidth: 100,
          cellAtrrs: {
            mes: 2
          },
          formatter: (props) => {
            if (props.February == 0) {
              return "";
            }
            return formatMonto(props.February);
          }
        },
        {
          prop: "March",
          name: "Marzo",
          label: "Marzo",
          minWidth: 100,
          cellAtrrs: {
            mes: 3
          },
          formatter: (props) => {
            if (props.March == 0) {
              return "";
            }
            return formatMonto(props.March);
          }
        },
        {
          prop: "April",
          name: "Abril",
          label: "Abril",
          minWidth: 100,
          cellAtrrs: {
            mes: 4
          },
          formatter: (props) => {
            if (props.April == 0) {
              return "";
            }
            return formatMonto(props.April);
          }
        },
        {
          prop: "May",
          name: "Mayo",
          label: "Mayo",
          minWidth: 100,
          cellAtrrs: {
            mes: 5
          },
          formatter: (props) => {
            if (props.May == 0) {
              return "";
            }
            return formatMonto(props.May);
          }
        },
        {
          prop: "June",
          name: "Junio",
          label: "Junio",
          minWidth: 100,
          cellAtrrs: {
            mes: 6
          },
          formatter: (props) => {
            if (props.June == 0) {
              return "";
            }
            return formatMonto(props.June);
          }
        },
        {
          prop: "July",
          name: "Julio",
          label: "Julio",
          minWidth: 100,
          cellAtrrs: {
            mes: 7,
            mes2: "July"
          },
          formatter: (props) => {
            if (props.July == 0) {
              return "";
            }
            return formatMonto(props.July);
          }
        },
        {
          prop: "August",
          name: "Agosto",
          label: "Agosto",
          minWidth: 100,
          cellAtrrs: {
            mes: 8
          },
          formatter: (props) => {
            if (props.August == 0) {
              return "";
            }
            return formatMonto(props.August);
          }
        },
        {
          prop: "September",
          name: "Septiembre",
          label: "Septiembre",
          cellAtrrs: {
            mes: 9
          },
          minWidth: 120,
          formatter: (props) => {
            if (props.September == 0) {
              return "";
            }
            return formatMonto(props.September);
          }
        },
        {
          prop: "October",
          name: "Octubre",
          label: "Octubre",
          cellAtrrs: {
            mes: 10
          },
          minWidth: 100,
          formatter: (props) => {
            if (props.October == 0) {
              return "";
            }
            return formatMonto(props.October);
          }
        },
        {
          prop: "November",
          name: "Noviembre",
          label: "Noviembre",
          cellAtrrs: {
            mes: 11
          },
          minWidth: 120,
          formatter: (props) => {
            if (props.November == 0) {
              return "";
            }
            return formatMonto(props.November);
          }
        },
        {
          prop: "December",
          name: "Diciembre",
          label: "Diciembre",
          cellAtrrs: {
            mes: 12
          },
          minWidth: 110,
          formatter: (props) => {
            if (props.December == 0) {
              return "";
            }
            return formatMonto(props.December);
          }
        }
      ]
    };
  },
  mounted() {
    this.getGoalSeller();
  },
  computed: {
    years() {
      const lowLevel = 2014;
      const currentYear = new Date().getFullYear();
      let Years = [];
      for (var i = lowLevel; i <= currentYear + 1; i++) {
        Years.push({ label: i, value: i });
      }
      return Years;
    }
  },
  methods: {
    formatMonto,
    handleClosed() {
      this.drawer = false;
      this.drawerEditar = false;
      this.ruleForm = {
        JanuaryGoal: "",
        FebruaryGoal: "",
        MarchGoal: "",
        AprilGoal: "",
        MayGoal: "",
        JuneGoal: "",
        JulyGoal: "",
        AugustGoal: "",
        SeptemberGoal: "",
        OctoberGoal: "",
        NovemberGoal: "",
        DecemberGoal: "",
        YearGoal: new Date().getFullYear(),
        seller_filter: "",
        metasValue: ""
      };
    },
    getGoalSeller() {
      this.autoLoading = true;
      this.$http
        .get("/api/deals/GetGoalsSellerTwo", {
          params: {
            Cod_Vendor: this.sellerId,
            Year: this.year,
            CompanyId: "TB",
            Type: this.typeFilter
          },
          timeout: 3 * 60 * 100
        })
        .then((resp) => {
          this.data = resp.data;
        })
        .catch((error) => {
          this.$message.error("Error al cargar detalles", error);
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },
    AddGoalSeller() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.autoLoading = true;
          this.$http
            .get("/api/deals/AddGoals", {
              params: {
                Cod_Vendor: this.ruleForm.seller_filter,
                Type: this.ruleForm.metasValue,
                January: this.ruleForm.JanuaryGoal,
                February: this.ruleForm.FebruaryGoal,
                March: this.ruleForm.MarchGoal,
                April: this.ruleForm.AprilGoal,
                May: this.ruleForm.MayGoal,
                June: this.ruleForm.JuneGoal,
                July: this.ruleForm.JulyGoal,
                August: this.ruleForm.AugustGoal,
                September: this.ruleForm.SeptemberGoal,
                October: this.ruleForm.OctoberGoal,
                November: this.ruleForm.NovemberGoal,
                December: this.ruleForm.DecemberGoal,
                Year: this.ruleForm.YearGoal,
                CompanyId: this.CompanyIDD
              },
              timeout: 3 * 60 * 100
            })
            .then((resp) => {
              this.data = resp.data;
            })
            .catch((error) => {
              this.$message.error("Error al cargar detalles", error);
            })
            .finally(() => {
              this.autoLoading = false;
              this.drawer = false;
              this.refreshData2();
              this.ruleForm = {
                JanuaryGoal: "",
                FebruaryGoal: "",
                MarchGoal: "",
                AprilGoal: "",
                MayGoal: "",
                JuneGoal: "",
                JulyGoal: "",
                AugustGoal: "",
                SeptemberGoal: "",
                OctoberGoal: "",
                NovemberGoal: "",
                DecemberGoal: "",
                YearGoal: new Date().getFullYear(),
                seller_filter: "",
                metasValue: ""
              };
            });
          this.autoLoading = true;
        } else {
          return false;
        }
      });
    },

    async onPushAction(c) {
      switch (c.command) {
        case "edit": {
          this.drawerTitle = `Editar Meta de ${c.row.NombreVendedor}`;
          // console.log("ok", c);

          (this.typeForDrawer = c.row.Type),
            (this.codeVendorForDrawer = c.row.Cod_Vendor),
            (this.JanuaryForDrawer = c.row.January),
            (this.FebruaryForDrawer = c.row.February),
            (this.MarchForDrawer = c.row.March),
            (this.AprilForDrawer = c.row.April),
            (this.MayForDrawer = c.row.May),
            (this.JuneForDrawer = c.row.June),
            (this.JulyForDrawer = c.row.July),
            (this.AugustForDrawer = c.row.August),
            (this.SeptemberForDrawer = c.row.September),
            (this.OctoberForDrawer = c.row.October),
            (this.NovemberForDrawer = c.row.November),
            (this.DecemberForDrawer = c.row.December),
            (this.YearDrawer = c.row.Year),
            this.$refs.GoalsFormDrawer.handleOpen();
          // this.goalBind.isEdit = true;
          break;
        }
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }
        const values = data.map((item) => item[column.property]);
        sums[index] = values.reduce((prev, curr) => {
          if (typeof prev == typeof "") {
            prev = parseFloat(prev.replace(",", ""));
          }
          curr = parseFloat(curr.replace(",", ""));
          const value = parseFloat(curr);
          if (value) {
            let sum = prev + curr;
            sum = this.mountFormatter.format(sum);
            return sum;
          } else {
            return this.mountFormatter.format(prev);
          }
        }, 0);
      });
      return sums;
    },
    refreshData() {
      this.$refs.table.refreshTable();
    },
    refreshData2() {
      this.getGoalSeller();
    }
  },
  watch: {
    typeFilter() {
      this.getGoalSeller();
    },
    year() {
      this.getGoalSeller();
    },
    sellerId() {
      this.getGoalSeller();
    }
  }
};
</script>

<style scoped>
.demo-form .cardInputs h3 {
  text-align: center;
}
.demo-form .cardInputs {
  box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
  -webkit-box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
  -moz-box-shadow: 7px 11px 16px -2px rgba(0, 0, 0, 0.33);
}
</style>
